import { useCallback, useEffect, useState } from 'react';

import { fetchHomelessInfo } from 'api/homeless';

export default function useMemberInfo(memberId: number) {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isError, setIsError] = useState(false);
    const [memberInfo, setMemberInfo] = useState<any>(null);

    const fetch = useCallback(() => {
        setIsLoading(true);
        setIsError(false);
        setIsLoaded(false);
        setMemberInfo(null);

        fetchHomelessInfo(memberId)
            .then((res: Response) => res.json())
            .then((data: { samaritan_member: any }) => {
                setMemberInfo(data.samaritan_member);
                setIsLoaded(true);
                setIsLoading(false);
            })
            .catch(() => {
                setIsError(true);
                setIsLoading(false);
            });
    }, [memberId]);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return { memberInfo, isLoading, isLoaded, isError, refetch: fetch };
}
